<template>
  <div>
    <v-row v-for="(price,index) in this.currentArtwork.prices" :key="price.priceTypeId" :class="{'mt-0':index > 0}">
      <v-col cols="10">
        <v-currency-field
          :label="priceTypesList.find(i => i.id == price.priceTypeId).name"
          @input="$emit('onChange')"
          v-model="price.value">
        </v-currency-field>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="price.currencyId"
          :label="$t('artwork.currency')"
          @change="$emit('onChange')"
          :items="currenciesList"
          item-text="code"
          item-value="id">
          <template slot="selection" slot-scope="data">
            {{ data.item.symbol }} ({{ data.item.code }})
          </template>
          <template slot="item" slot-scope="data">
            {{ data.item.symbol }} ({{ data.item.code }})
          </template>
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  mounted () {
    this.createFields()
  },
  computed: {
    currentArtwork () {
      return this.$store.getters['artworks/currentArtwork']
    },
    priceTypesList () {
      return this.$store.getters['priceTypes/priceTypesList']
    },
    currenciesList () {
      return this.$store.getters['currencies/currenciesList']
    }
  },
  methods: {
    createFields () {
      var defaultCurrencyId = 0

      if (this.currenciesList.length > 0) {
        defaultCurrencyId = this.currenciesList[0].id
      }

      this.priceTypesList.forEach(item => {
        var existingItem = this.currentArtwork.prices.find(i => i.priceTypeId === item.id)

        if (existingItem == null) {
          this.currentArtwork.prices.push({
            priceTypeId: item.id,
            value: 0,
            currencyId: defaultCurrencyId
          })
        }
      })
    }
  },
  watch: {
    currentArtwork () {
      this.createFields()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/prices/PricesEditor.vue